/**
 * Created by koqiui on 2017-04-09.
 */
import {Utils} from '../../app.base'
import {MsgBox, Vue, Routes} from '../../app.vues';
//
import SwbCategTreeMultiSelect from './CategTreeMultiSelect';
Vue.regist(SwbCategTreeMultiSelect);

import SwbCategTreeMultiSelectTwo from './CategTreeMultiSelectTwo';
Vue.regist(SwbCategTreeMultiSelectTwo);

import SwbServcCategTreeMultiSelect from './ServcCategTreeMultiSelect';
Vue.regist(SwbServcCategTreeMultiSelect);

import SwbCategTreeForSelect from './CategTreeForSelect';
Vue.regist(SwbCategTreeForSelect);

import SwbDevcGroupSave from './DevcGroupSave';
Vue.regist(SwbDevcGroupSave);

import SwbGoodsCatDevcGroupList from './GoodsCatDevcGroupList';
Vue.regist(SwbGoodsCatDevcGroupList);

import SwbDevcCatListForSelect from './DevcCatListForSelect';
Vue.regist(SwbDevcCatListForSelect);

import SwbDevcBrandListForSelect from './DevcBrandListForSelect';
Vue.regist(SwbDevcBrandListForSelect);

//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openCategTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    if (model == null) {
        model = {};
        model.catIdColumn = "catId"; //
        model.catNameColumn = "catName";
    }
    let defaultCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '商品分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-categ-tree-multi-select :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_categ_tree_multi_select"></swb-categ-tree-multi-select>' +
        '</div>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_categ_tree_multi_select.getDlgResult() || {};
            // if(result.type == "info") {
            //     let catList = result.data;
            //     //
            //     console.log(catList);
            //     callback(catList);
            // } else {
            //     MsgBox.warning(result.message);
            //     return false;
            // }
            callback(result);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}
//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openCategTreeMultiSelectDlgTwo(dlgConfig = {}, displayDataList = [], callback) {
    //
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let showNoRelCat = dlgConfig['showNoRelCat'] || false; // 是否展示未关联分类页签
    let model = dlgConfig['model'] || null;
    if (model == null) {
        model = {};
        model.catIdColumn = "catId"; //
        model.catLevelColumn = "catLevel";
        model.catNameColumn = "catName";
    }
    let defaultCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-categ-tree-multi-select-two :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :showNoRelCat="showNoRelCat" :model = "model" ref="swb_categ_tree_multi_select"></swb-categ-tree-multi-select-two>' +
        '</div>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            showNoRelCat: showNoRelCat,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_categ_tree_multi_select.getDlgResult() || {};
            // if(result.type == "info") {
            //     let catList = result.data;
            //     //
            //     console.log(catList);
            //     callback(catList);
            // } else {
            //     MsgBox.warning(result.message);
            //     return false;
            // }
            callback(result);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}
//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openCategTreeSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let multipleSelect = dlgConfig['multipleSelect'] || false;
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let showRadioLevel1 = dlgConfig['showRadioLevel1'] || false;
    let showRadioLevel2 = dlgConfig['showRadioLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    if (model == null) {
        model = {};
        model.catIdColumn = "catId"; //
        model.catLevelColumn = "catLevel";
        model.catNameColumn = "catName";
    }
    let defaultCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '商品分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-categ-tree-for-select :multipleSelect="multipleSelect" :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_categ_tree_for_select"></swb-categ-tree-for-select>' +
        '</div>',
        data: {
            multipleSelect: multipleSelect,
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_categ_tree_for_select.getDlgResult() || {};
            callback(result.data);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}
//TODO displayDataList [{catId,catId1,catId2,catId3}] 回显必传
export function openServcCategTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    //
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    let defaultCheckedItems = displayDataList || [];
    //
    Vue.$showDialog({
        title: '服务分类 - 选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        //okVisible: true,
        // cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-categ-tree-multi-select :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_servc_categ_tree_multi_select"></swb-servc-categ-tree-multi-select>' +
        '</div>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_categ_tree_multi_select.getDlgResult() || {};
            // if(result.type == "info") {
            //     let catList = result.data;
            //     //
            //     console.log(catList);
            //     callback(catList);
            // } else {
            //     return false;
            // }
            callback(result);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

//
import SwbBrandListForSelect from './BrandListForSelect';
Vue.regist(SwbBrandListForSelect);
//
export function openBrandListSelectDlg(checkBox, dlgConfig, callback) {
    let selectIds = dlgConfig['selectIds'] || [];
    let catId = dlgConfig['catId'] || null;
    let showAll = Utils.isTrue(dlgConfig['showAll']);
    let currentCheckValue = dlgConfig['currentCheckValue'] || null;
    let deleted = dlgConfig['deleted'];
    Vue.$showDialog({
        title: '品牌 - 选择',
        width: 900,
        height: 800,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-brand-list-for-select :checkBox = "checkBox" :showAll="showAll" :selectIds="selectIds" :catId="catId" :deleted="deleted" :currentCheckValue="currentCheckValue" ref="swb_brand_list_for_select"></swb-brand-list-for-select>' +
        '</div>',
        data: {
            checkBox: null,
            showAll: showAll,
            selectIds: selectIds,
            catId: catId,
            currentCheckValue: currentCheckValue,
            deleted: deleted
        },
        methods: {},
        okClicked: function () {
            let result = this.$refs.swb_brand_list_for_select.getDlgResult() || {};
            if (result.type === 'info') {
                let brandList = result.data || [];
                callback(brandList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
                this.checkBox = checkBox || false;
            }
        }
    });
}

// 设备分组保存
export function openDevcGroupDlg(id, parentId, callback) {
    //
    let title = Utils.isNoB(id) ? "维保分组 - 新增" : "维保分组 - 修改";
    let theDlg = Vue.$showDialog({
        title: title,
        width: 500,
        height: 400,
        showCloseBtn: true,
        okVisible: true,
        template: '<div class = "">' +
        '<swb-devc-group-save :id = "id" :parentId="parentId" ref="swb_devc_group_save"></swb-devc-group-save>' +
        '</div>',
        data: {
            id: id || null,
            parentId: parentId
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_group_save.getDlgResult() || {};
            if (result.type == 'info') {
                callback(result.data, theDlg);
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 商品分类设备分组列表
export function openGoodsCatDevcGroupListDlg(groupId, groupName, showAddFlag) {
    if (Utils.isNoB(groupId)) {
        MsgBox.warning("参数错误");
        return;
    }
    //
    Vue.$showDialog({
        title: '已关联分类 - 查看',
        width: -500,
        height: 900,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-goods-cat-devc-group-list :groupId = "groupId" :groupName="groupName" :showAddFlag="showAddFlag" ref="swb_goods_cat_devc_group_list"></swb-goods-cat-devc-group-list>' +
        '</div>',
        data: {
            groupId: groupId,
            groupName: groupName,
            showAddFlag: showAddFlag,
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

// 自有资产分类选择列表
export function showDevcCatSelectDlg(dlgConfig, callback) {
    let filter = dlgConfig["filter"] || {};
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let checkIsNull = dlgConfig["checkIsNull"] || false;
    let theDlg = Vue.$showDialog({
        title: '自有资产分类 - 选择',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-devc-cat-list-for-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" :checkIsNull="checkIsNull" ref="swb_devc_cat_list_for_select"></swb-devc-cat-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            selectIds: selectIds,
            checkIsNull: checkIsNull
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_devc_cat_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    callback(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

// 自有资产品牌选择列表
export function showDevcBrandSelectDlg(dlgConfig, callback) {
    let filter = dlgConfig["filter"] || {};
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let theDlg = Vue.$showDialog({
        title: '自有资产品牌 - 选择',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-devc-brand-list-for-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" ref="swb_devc_brand_list_for_select"></swb-devc-brand-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_devc_brand_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    callback(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

import SwbDevcCatSave from './DevcCatSave.vue'
Vue.regist(SwbDevcCatSave);
// 商品分类设备分组列表
export function openDevcCatSaveDlg(params, callBack) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? '自有资产分类 - 新增' : '自有资产分类 - 编辑';
    //
    let okVisible = (params.level == 3 && params["enableApply"]) || false;
    Vue.$showDialog({
        title: title,
        width: 700,
        height: 800,
        okVisible: okVisible,
        okText: "申请",
        showCloseBtn: true,
        cancelText: "保存",
        extVisible: true,
        extText: "关闭",
        template: '<swb-devc-cat-save :item = "params" ref="swb_devc_cat_save"></swb-devc-cat-save>',
        data: {
            params: params
        },
        okClicked: function () {    // 申请
            let self = this;
            let result = self.$refs.swb_devc_cat_save.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data, true);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        cancelClicked: function () {    // 保存
            let self = this;
            let result = self.$refs.swb_devc_cat_save.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data, false);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        extClicked: function () {   // 取消
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcCatImpCheck from './DevcCatImpCheck.vue'
Vue.regist(SwbDevcCatImpCheck);

//机构设备导入检查
export function openDevcCatImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "自有资产分类导入检查",
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-devc-cat-imp-check  @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_devc_cat_imp_check"></swb-devc-cat-imp-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose(){
                callback();
                theDlg.close();
            }
        },
        extClicked: function () {
            theDlg.close();
        },
    });
};

import SwbDevcCatDetail from './DevcCatDetail'
Vue.regist(SwbDevcCatDetail);
// 商品分类设备分组列表
export function openDevcCatDetailDlg(id) {
    if (Utils.isNoB(id)) {
        MsgBox.warning("参数错误");
        return;
    }
    //
    Vue.$showDialog({
        title: '分类 - 查看',
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-devc-cat-detail :id = "id" ref="swb_devc_cat_detail"></swb-devc-cat-detail>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}
import SwbDevcCatFormatExpl from './DevcCatFormatExpl'
Vue.regist(SwbDevcCatFormatExpl);
// 商品分类设备分组列表
export function openDevcCatFormatExplDlg() {
    Vue.$showDialog({
        title: '分类导入 - 说明',
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-devc-cat-format-expl ref="swb_devc_cat_format_expl"></swb-devc-cat-format-expl>' +
        '</div>',
        data: {},
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcCatApplyRecList from './DevcCatApplyRecList'
Vue.regist(SwbDevcCatApplyRecList);
// 商品分类设备分组列表
export function openDevcCatApplyRecListDlg(id) {
    let theDlg = Vue.$showDialog({
        title: '申请-记录',
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-devc-cat-apply-rec-list :id="id" ref="swb_devc_cat_apply_rec_list"></swb-devc-cat-apply-rec-list>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        cancelClicked: function () {
            theDlg.close();
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcBrandSave from './DevcBrandSave.vue'
Vue.regist(SwbDevcBrandSave);
// 自有资产品牌新增
export function openDevcBrandSaveDlg(params, callBack) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? '自有资产品牌 - 新增' : '自有资产品牌 - 编辑'
    Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        showCloseBtn: true,
        okVisible: true,
        template: '<div class = "">' +
        '<swb-devc-brand-save :id = "id"  ref="swb_devc_brand_save"></swb-devc-brand-save>' +
        '</div>',
        data: {
            id: id,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_brand_save.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcBrandDetail from './DevcBrandDetail'
Vue.regist(SwbDevcBrandDetail);
// 自有资产品牌查看
export function openDevcBrandDetailDlg(id) {
    if (Utils.isNoB(id)) {
        MsgBox.warning("参数错误");
        return;
    }
    //
    Vue.$showDialog({
        title: '品牌 - 查看',
        width: 600,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-devc-brand-detail :id = "id" ref="swb_devc_brand_detail"></swb-devc-brand-detail>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbBrandSelect from './BrandSelect.vue'
Vue.regist(SwbBrandSelect);
// 自有资产品牌新增
export function openBrandSelectDlg(callBack) {
    Vue.$showDialog({
        title: '平台品牌-选择',
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: true,
        template: '<div class = "">' +
        '<swb-brand-select  ref="swb_brand_select"></swb-brand-select>' +
        '</div>',
        data: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_brand_select.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcBrandImpCheck from './DevcBrandImpCheck.vue'
Vue.regist(SwbDevcBrandImpCheck);
//自有资产品牌导入
export function openDevcBrandImpCheckDlg(fileObj, callback) {
    let theDlg = null;
    theDlg = Vue.$showDialog({
        title: "自有资产品牌导入检查",
        width: -100,
        height: -20,
        okVisible: false,
        cancelVisible: false,
        extVisible: true,
        showCloseBtn: true,
        okText: '整体导入',
        extText: '关闭',
        cancelText: '整体检查',
        template: '<swb-devc-brand-imp-check  @other-close="otherClose" :rootWidth="dlgBodyWidth" :rootHeight="dlgBodyHeight" :fileObj="fileObj" ref="swb_devc_brand_imp_check"></swb-devc-brand-imp-check>',
        data: {
            fileObj: fileObj,
            dlgBodyWidth: 900,
            dlgBodyHeight: 680,
        },
        methods: {
            dlgBodyResized(width, height){
                this.dlgBodyWidth = width;
                this.dlgBodyHeight = height;
            },
            otherClose(){
                callback();
                theDlg.close();
            }
        },
        extClicked: function () {
            theDlg.close();
        },
    });
};

import SwbDevcBrandFormatExpl from './DevcBrandFormatExpl'
Vue.regist(SwbDevcBrandFormatExpl);
// 商品分类设备分组列表
export function openDevcBrandFormatExplDlg() {
    Vue.$showDialog({
        title: '品牌导入 - 说明',
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-devc-brand-format-expl ref="swb_devc_brand_format_expl"></swb-devc-brand-format-expl>' +
        '</div>',
        data: {},
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcBrandApplyRecList from './DevcBrandApplyRecList'
Vue.regist(SwbDevcBrandApplyRecList);
// 商品分类设备分组列表
export function openDevcBrandApplyRecListDlg(id) {
    Vue.$showDialog({
        title: '申请-记录',
        width: 1000,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-devc-brand-apply-rec-list :id="id" ref="swb_devc_brand_apply_rec_list"></swb-devc-brand-apply-rec-list>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbAssetKindSave from './AssetKindSave'
Vue.regist(SwbAssetKindSave);
// 商品分类设备分组列表
export function openAssetKindSaveDlg(params, callBack) {
    let id = params["id"] || null;
    let title = Utils.isNoB(id) ? '财务类别 - 新增' : '财务类别 - 编辑';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        showCloseBtn: true,
        okVisible: true,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-asset-kind-save :item="params" ref="swb_asset_kind_save"></swb-asset-kind-save>' +
        '</div>',
        data: {
            params: params
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asset_kind_save.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbAssetKindDetail from './AssetKindDetail'
Vue.regist(SwbAssetKindDetail);
// 商品分类设备分组列表
export function openAssetKindDetailDlg(id) {
    if (Utils.isNoB(id)) {
        MsgBox.warning("参数错误");
        return;
    }
    //
    Vue.$showDialog({
        title: '财务类别 - 查看',
        width: 600,
        height: 500,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<div class = "">' +
        '<swb-asset-kind-detail :id = "id" ref="swb_asset_kind_detail"></swb-asset-kind-detail>' +
        '</div>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbAssetKindListSelect from './AssetKindListSelect'
Vue.regist(SwbAssetKindListSelect);
// 商品分类设备分组列表
export function openAssetKindListSelectDlg(params, callBack) {
    let theDlg = Vue.$showDialog({
            title: '财务类别 - 选择',
            width: 1200,
            height: 900,
            showCloseBtn: true,
            okVisible: true,
            cancelText: '关闭',
            template: '<div class = "">' +
            '<swb-asset-kind-list-select :checkBox="checkBox" :selectIds="selectIds" :notIncludedfirstLevelFlag="notIncludedfirstLevelFlag" :assetNatures="assetNatures" :hasDeprSpec="hasDeprSpec" ref="swb_asset_kind_list_select"></swb-asset-kind-list-select>' +
            '</div>',
            data: {
                checkBox: params["checkBox"] || false,
                notIncludedfirstLevelFlag: params["notIncludedfirstLevelFlag"],
                selectIds: params["selectIds"] || false,
                hasDeprSpec: params["hasDeprSpec"],
                assetNatures: params["assetNatures"]
            },
            okClicked: function () {
                let self = this;
                let result = self.$refs.swb_asset_kind_list_select.getDlgResult() || {};
                if (result.type == 'info') {
                    callBack(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                    return false;
                }
            }
            ,
            lifecycle: {
                created: function () {
                }
            }
            ,
        })
    ;
}

import SwbCategAndDevcCatTreeMultiSelect from './CategAndDevcCatTreeMultiSelect';
Vue.regist(SwbCategAndDevcCatTreeMultiSelect);

export function openCategAndDevcCatTreeMultiSelectDlg(dlgConfig = {}, displayDataList = [], callback) {
    if (Utils.isNoB(callback)) {
        MsgBox.warning("回调函数不可为空");
        return;
    }
    if (typeof callback != "function") {
        MsgBox.warning("callback 不是回调函数，请确认");
        return;
    }
    //
    let noPostFilters = dlgConfig['noPostFilters'] || false;
    let showCheckboxLevel1 = dlgConfig['showCheckboxLevel1'] || false;
    let showCheckboxLevel2 = dlgConfig['showCheckboxLevel2'] || false;
    let checkStrictly = dlgConfig['checkStrictly'] || false;
    let model = dlgConfig['model'] || null;
    if (model == null) {
        model = {};
        model.catIdColumn = "catId"; //
        model.catLevelColumn = "catLevel";
        model.catNameColumn = "catName";
    }
    let defaultCheckedItems = displayDataList || [];
    Vue.$showDialog({
        title: '分类 - 选择',
        width: -500,
        height: 900,
        showCloseBtn: true,
        template: '<swb-categ-and-devcCat-tree-multi-select :noPostFilters = "noPostFilters" :showCheckboxLevel1="showCheckboxLevel1" :showCheckboxLevel2 = "showCheckboxLevel2" :checkStrictly = "checkStrictly" :defaultCheckedItems = "defaultCheckedItems" :model = "model" ref="swb_categ_and_devcCat_tree_multi_select"></swb-categ-and-devcCat-tree-multi-select>',
        data: {
            noPostFilters: noPostFilters,
            showCheckboxLevel1: showCheckboxLevel1,
            showCheckboxLevel2: showCheckboxLevel2,
            checkStrictly: checkStrictly,
            defaultCheckedItems: defaultCheckedItems,
            model: model
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_categ_and_devcCat_tree_multi_select.getDlgResult() || {};
            callback(result);
        },
        lifecycle: {
            created: function () {
            }
        },
    });
}

import SwbDevcGroupListForSelect from './DevcGroupListForSelect';
Vue.regist(SwbDevcGroupListForSelect);
// 维保分组选择
export function showDevcGroupSelectDlg(dlgConfig, callback) {
    let filter = dlgConfig["filter"] || {};
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let theDlg = Vue.$showDialog({
        title: '维保分组 - 选择',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-devc-group-list-for-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" ref="swb_devc_group_list_for_select"></swb-devc-group-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_devc_group_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    callback(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

import SwbDevcGroupCatListForSelect from './DevcGroupCatListForSelect';
Vue.regist(SwbDevcGroupCatListForSelect);
// 维保分组分类选择
export function showDevcGroupCatSelectDlg(dlgConfig, callback) {
    let filter = dlgConfig["filter"] || {};
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let theDlg = Vue.$showDialog({
        title: '商品分类 - 选择',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-devc-group-cat-list-for-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" ref="swb_devc_group_cat_list_for_select"></swb-devc-group-cat-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_devc_group_cat_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    callback(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

import SwbDevcGroupPartListForSelect from './DevcGroupPartListForSelect';
Vue.regist(SwbDevcGroupPartListForSelect);
// 维保分组分类选择
export function showDevcGroupPartSelectDlg(dlgConfig, callback) {
    let filter = dlgConfig["filter"] || {};
    let checkBox = dlgConfig["checkBox"] == null ? false : dlgConfig["checkBox"];
    let selectIds = dlgConfig["selectIds"] || [];
    let theDlg = Vue.$showDialog({
        title: '维保分组部件 - 选择',
        width: 1200,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-devc-group-part-list-for-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" ref="swb_devc_group_part_list_for_select"></swb-devc-group-part-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            selectIds: selectIds
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_devc_group_part_list_for_select.getDlgResult() || {};
                if (result.type === 'info') {
                    callback(result.data, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/categ/selectDlg.js
// module id = 35
// module chunks = 0